import { Body1, Body2, BrandGraphic, Display2, XStack, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import type { Feeling } from "../natera-intake/persona";
import { copy } from "./copy";

/**
 * The concern said back to the member before sign-up — a fork of the funnel's
 * PersonaValidation (general variant).
 */
export function RoutingValidation({
  feeling,
  onContinue
}: {
  feeling: Feeling;
  onContinue: () => void;
}) {
  const {
    title,
    body
  } = copy.validation[feeling];
  return <OnboardingScreen tone="dark" data-sentry-element="OnboardingScreen" data-sentry-component="RoutingValidation" data-sentry-source-file="RoutingValidation.tsx">
      <OnboardingScreen.Nav data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="RoutingValidation.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="RoutingValidation.tsx">
        {/* Not `OnboardingScreen.Header`, which paints its title `$textInverse`:
            the lime title is this screen's signature. Everything else matches
            the Header's own spacing. */}
        <YStack gap="$sp1.5" paddingBottom="$sp8" testID={`intake-routing.validation-${feeling}`} data-sentry-element="YStack" data-sentry-source-file="RoutingValidation.tsx">
          <Display2 color="$textInverseBrand" data-sentry-element="Display2" data-sentry-source-file="RoutingValidation.tsx">{title}</Display2>
          <Body1 color="$textInverseSubtle" data-sentry-element="Body1" data-sentry-source-file="RoutingValidation.tsx">{body}</Body1>
        </YStack>
        <XStack justifyContent="center" marginVertical="auto" data-sentry-element="XStack" data-sentry-source-file="RoutingValidation.tsx">
          <BrandGraphic type="bill" indicator="check" size="$si14" data-sentry-element="BrandGraphic" data-sentry-source-file="RoutingValidation.tsx" />
        </XStack>
      </OnboardingScreen.Content>
      <OnboardingScreen.Footer data-sentry-element="OnboardingScreen.Footer" data-sentry-source-file="RoutingValidation.tsx">
        <Body2 textAlign="center" color="$textInverseMuted" data-sentry-element="Body2" data-sentry-source-file="RoutingValidation.tsx">
          {copy.validation.caption}
        </Body2>
        <OnboardingScreen.PrimaryAction testID="intake-routing.validation-continue" variant="brand" onPress={onContinue} data-sentry-element="OnboardingScreen.PrimaryAction" data-sentry-source-file="RoutingValidation.tsx">
          {copy.validation.cta}
        </OnboardingScreen.PrimaryAction>
      </OnboardingScreen.Footer>
    </OnboardingScreen>;
}